import * as openpgp from "openpgp";
import { getKeys } from "./getKeys";
import { decryptPrivateKey } from "./decryptPrivateKey";
import { readFile } from "./readFile";
import { readFileFromBase64 } from "./readFileFromBase64";
import { IDecryptedKeys } from "./decryptKeys";
import { IKey } from "dto/IKey";

export const readParentKey = async (
  myKeys: IDecryptedKeys,
  keys: IKey,
  parentKeys: IKey,
) => {
  console.log(parentKeys);
  const decryptParentKey = await decryptPrivateKey(myKeys!, parentKeys);
  const text = await openpgp.key.read(decryptParentKey.data);
  const PK = await readFileFromBase64(keys.PrivateKey!, "application/other");
  const msg = await openpgp.message.read(new Uint8Array(PK));

  const options: openpgp.DecryptOptions = {
    message: msg,
    privateKeys: text.keys[0],
    format: "binary",
  };

  return await openpgp.decrypt(options);
};

const readArmoredParentKey = async (
  myKeys: IDecryptedKeys,
  keys: IKey,
  parentKeys: IKey,
) => {
  const decryptParentKey = await decryptPrivateKey(myKeys!, parentKeys);

  const string = new TextDecoder().decode(decryptParentKey.data);
  const armored = atob(string);
  const text = await openpgp.key.readArmored(armored);
  //@ts-ignore
  //
  const PK = await readFileFromBase64(keys.PrivateKey, "application/other");

  const msg = await openpgp.message.read(new Uint8Array(PK));

  const options: openpgp.DecryptOptions = {
    message: msg,
    privateKeys: text.keys[0],
    format: "binary",
  };

  return await openpgp.decrypt(options);
};

export const decryptFile = async (
  userId: string,
  file: Blob,
  keys: IKey,
  parentKeys?: IKey | undefined | null,
  chatId?: string,
): Promise<Blob> => {
  try {
    const myKeys = await getKeys(userId, chatId);
    let privateKey: null | openpgp.DecryptResult = null;

    if (parentKeys) {
      try {
        console.log("1");
        privateKey = await readParentKey(myKeys!, keys, parentKeys);
      } catch (e) {
        privateKey = await readArmoredParentKey(myKeys!, keys, parentKeys);
      }
    } else {
      privateKey = await decryptPrivateKey(myKeys!, keys);
    }

    console.log("przewzło");

    const xfile = await openpgp.message.read(
      new Uint8Array(await readFile(file)),
    );

    let decryptedFile: null | openpgp.DecryptResult = null;

    if (!privateKey) {
      throw new Error("Private key not found");
    }

    try {
      const key = await openpgp.key.read(privateKey.data);

      if (keys.EmptyPassphrase) {
        console.log("odpalam passphrase");
        key.keys[0].decrypt("");
      }

      decryptedFile = await openpgp.decrypt({
        message: xfile,
        privateKeys: key.keys[0],
        format: "binary",
      });

      console.log("przeszło decrypt");

      return new Blob([decryptedFile.data]);
    } catch (e) {
      console.log(e);
      const string = new TextDecoder().decode(privateKey.data);
      const armored = atob(string);
      const key = await openpgp.key.readArmored(armored);

      decryptedFile = await openpgp.decrypt({
        message: xfile,
        privateKeys: key.keys[0],
        format: "binary",
      });
    }

    return new Blob([decryptedFile.data]);
  } catch (e: any) {
    throw new Error(e.message);
  }
};
